var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-image"},[_c('figure',{staticClass:"hero-image__ratio"},[_c('img',{attrs:{"src":_vm.getImage,"alt":"Alt description for the image"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }